/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Retail {

    import fld = GiftVoucherSalesDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class GiftVoucherSalesDetailsEditor extends _Ext.ItemGridEditor<GiftVoucherSalesDetailsRow> {


        protected getColumnsKey() { return "Retail.GiftVoucherSalesDetails"; }
        protected getDialogType() { return GiftVoucherSalesDetailsDialog; }
        protected getLocalTextPrefix() { return GiftVoucherSalesDetailsRow.localTextPrefix; }
        protected form: GiftVoucherSalesDetailsForm;

        public pendingChanges: Q.Dictionary<any> = {};
        public CompanyId: number;
        public EmployeeId: number;
        constructor(container: JQuery) {
            super(container);


            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as GiftVoucherSalesDialog).CalculateTotals();
                }
            })

        }
        protected getButtons() {
            let buttons = super.getButtons();
            //var grid = OMS.ProductSelectGrid;
            buttons.pop();
            buttons.push({
                title: "Select Vouchers",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var grid = Common.GiftVoucherItemDetailsSelectGrid;
                    // **** Validate Party before Item Selection ****
                    //if (isNaN(this.PartyId)) {
                    //    Q.notifyWarning("Please select Supplier to proceed");
                    //    return;

                    //}
                    //else {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Gift Voucher",
                        preSelectedKeys: this.value.map(k => k.TransItemId)
                    });
                    //}

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems;//.filter(t => { return !Q.any(this.view.getItems(), n => n.TransItemId == t.TransItemId) });
                        var self = this;
                        var items = [];
                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: Common.GiftVoucherTransactionsRow) {


                            var Exchange: GiftVoucherSalesDetailsRow = {
                                Amount: value.Amount,
                                CompanyId: value.CompanyId,
                                EmployeeId: self.EmployeeId,
                                GvMasterId: value.GvMasterId,
                                GvNumber: value.GvNumber,
                                RefTransId: value.TransId,
                                RefTransItemId: value.Id,
                                UserId: Q.Authorization.userDefinition.UserId,
                               
                            };

                            items.push(Exchange);

                        });

                        for (let item of items) {
                            item[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(item);
                        }

                        // #endregion

                        // #endregion
                    }

                    pickerDialog.dialogOpen();
                }
            });


            return buttons;
        }
    }
}